import React from "react";
import MenuButton from "./MenuButton";
import "../../css/menu.css";
import AbstractMenu from "./AbstractMenu";
import SubmenuHeader from "./SubMenuHeader";
import { connect } from "react-redux";
import { Switch, Route } from "react-router-dom";
import IncomingStocks from "../../stockManagement/IncomingStocks";
import IncomingStocksNew from "../../stockManagement/incomingstocks/IncomingStocksNew";
import Suppliers from "../../stockManagement/Suppliers";
import Stores from "../../stockManagement/Stores";
import StockMovements from "../../stockManagement/StockMovements";
import Inventories from "../../stockManagement/Inventories";
import "../../stockManagement/style.css";
import auth, { startpoll } from "../../js/auth";
import InventoryScrapping from "../../stockManagement/InventoryScrapping";
import StockList from "../../stockManagement/StockList";
import StockStatistics from "../../stockManagement/StockStatistics";
import Barcodes from "../../stockManagement/Barcodes";
import ProfitAndLoss from "../../stockManagement/ProfitAndLoss";
import ShoppingList from "../../stockManagement/ShoppingList";
import CanAccess from "../CanAccess";


class StockManagementMenu extends AbstractMenu {

  componentDidMount = () => {

    if (typeof localStorage.admin_stocklist_timestamp === undefined || (new Date().getTime() - Number(localStorage.admin_stocklist_timestamp)) > 1000 * 3600 * 8) {
      localStorage.admin_stocklist_end = new Date().getTime();
      localStorage.admin_stocklist_start = new Date().getTime() - 1000 * 3600 * 24 * 7;
      localStorage.admin_stocklist_timestamp = new Date().getTime();
    }
    localStorage.admin_stocklist_timestamp = new Date().getTime();
    if (this.props?.myStatus?.sessionId) startpoll(auth.serverSideMessageHandler, [{ Restaurant: localStorage.restaurantSelected }]);
  }

  componentDidUpdate = () => {
    if (this.props?.myStatus?.sessionId) startpoll(auth.serverSideMessageHandler, [{ Restaurant: localStorage.restaurantSelected }]);
  }

  render() {
    const { admin_local, myStatus } = this.props;
    const background = "#847556";
    if (admin_local)
      return (
        <Switch>
          <Route path="/stockManagementMenu/stockList" render={props => { return (<StockList />) }} />
          <Route path="/stockManagementMenu/shoppingList" render={props => { return (<ShoppingList />) }} />
          <Route path="/stockManagementMenu/stockStatistics" render={props => { return (<StockStatistics />) }} />
          <Route path="/stockManagementMenu/pandl" render={props => { return (<ProfitAndLoss />) }} />
          <Route path="/stockManagementMenu/incomingStocks/:id" render={props => { return (<IncomingStocks {...props} />) }} />
          <Route path="/stockManagementMenu/incomingStocks" render={props => { return (<IncomingStocks {...props} />) }} />
          <Route path="/stockManagementMenu/incomingStocksNew/:id" render={props => { return (<IncomingStocksNew {...props} />) }} />
          <Route path="/stockManagementMenu/incomingStocksNew" render={props => { return (<IncomingStocksNew {...props} />) }} />
          <Route path="/stockManagementMenu/suppliers" render={props => { return (<Suppliers />) }} />
          <Route path="/stockManagementMenu/stores" render={props => { return (<Stores />) }} />
          <Route path="/stockManagementMenu/stockMovements" render={props => { return (<StockMovements />) }} />
          <Route path="/stockManagementMenu/inventories" render={props => { return (<Inventories />) }} />
          <Route path="/stockManagementMenu/inventoryScrapping" render={props => { return (<InventoryScrapping />) }} />
          <Route path="/stockManagementMenu/barcodes" render={props => { return (<Barcodes />) }} />
          <Route path="/stockManagementMenu" render={props => {
            if (this.props?.myStatus?.sessionId) {
              return (
                <div className="mainMenuWrap" style={{ flexGrow: 1, display: "flex", flexFlow: "column" }}>
                  <SubmenuHeader {...this.props} header={admin_local.menus.stockManagement} />
                  <CanAccess resource="stockmanagement">
                    <div className="mainMenuGrid" style={{ flexGrow: 1 }}>
                      <CanAccess resource="stockmanagement.stocklist">
                        <MenuButton backgroundImage={require("../../img/menu-new/stock-warehouse.svg")} myStatus={myStatus} href="/stockManagementMenu/stockList" i="i_warehouse_inventory" background={background} name={admin_local.menus.stockList}></MenuButton>
                      </CanAccess>
                      <CanAccess resource="stockmanagement.shoppinglist">
                        <MenuButton backgroundImage={require("../../img/menu-new/shopping-bag.svg")} myStatus={myStatus} href="/stockManagementMenu/shoppingList" i="icon-dollar" background={background} name={admin_local.menus.shoppingList}></MenuButton>
                      </CanAccess>
                      <CanAccess resource="stockmanagement.stockstatistics">
                        <MenuButton backgroundImage={require("../../img/menu-new/bar-chart-2.svg")} myStatus={myStatus} href="/stockManagementMenu/stockStatistics" i="i_report" background={background} name={admin_local.menus.stockReport}></MenuButton>
                      </CanAccess>
                      <CanAccess resource="stockmanagement.pandl">
                        <MenuButton backgroundImage={require("../../img/menu-new/activity.svg")} myStatus={myStatus} href="/stockManagementMenu/pandl" i="i_report" background={background} name={admin_local.menus.analytics}></MenuButton>
                      </CanAccess>
                      <CanAccess resource="stockmanagement.incomingstocks">
                        <MenuButton backgroundImage={require("../../img/menu-new/stock-incoming.svg")} myStatus={myStatus} href="/stockManagementMenu/incomingStocksNew" i="i_box_incoming" background={background} name={admin_local.menus.incomingStocks}></MenuButton>
                      </CanAccess>
                      <CanAccess resource="stockmanagement.incomingstocks">
                        <MenuButton backgroundImage={require("../../img/menu-new/stock-incoming.svg")} myStatus={myStatus} href="/stockManagementMenu/incomingStocks" i="i_box_incoming" background={background} name={admin_local.menus.incomingStocks + " " + admin_local.old}></MenuButton>
                      </CanAccess>
                      <CanAccess resource="stockmanagement.stockmovements">
                        <MenuButton backgroundImage={require("../../img/menu-new/stock-movement.svg")} myStatus={myStatus} href="/stockManagementMenu/stockMovements" i="i_stock" background={background} name={admin_local.menus.stockMovements}></MenuButton>
                      </CanAccess>
                      <CanAccess resource="stockmanagement.inventories">
                        <MenuButton backgroundImage={require("../../img/menu-new/stock-inventory.svg")} myStatus={myStatus} href="/stockManagementMenu/inventories" i="i_inventory_list" background={background} name={admin_local.menus.inventory}></MenuButton>
                      </CanAccess>
                      <CanAccess resource="stockmanagement.inventoryscrapping">
                        <MenuButton backgroundImage={require("../../img/menu-new/stock-scrap.svg")} myStatus={myStatus} href="/stockManagementMenu/inventoryScrapping" i="i_scrap" background={background} name={admin_local.menus.inventoryScrapping}></MenuButton>
                      </CanAccess>
                      <CanAccess resource="stockmanagement.suppliers">
                        <MenuButton backgroundImage={require("../../img/menu-new/stock-supplier.svg")} myStatus={myStatus} href="/stockManagementMenu/suppliers" i="i_supplier" background={background} name={admin_local.menus.suppliers}></MenuButton>
                      </CanAccess>
                      <CanAccess resource="stockmanagement.stores">
                        <MenuButton backgroundImage={require("../../img/menu-new/stock-store.svg")} myStatus={myStatus} href="/stockManagementMenu/stores" i="i_inventory_quantity" background={background} name={admin_local.menus.stores}></MenuButton>
                      </CanAccess>
                      <CanAccess resource="stockmanagement.barcodes">
                        <MenuButton backgroundImage={require("../../img/menu-new/stock-barcodes.svg")} myStatus={myStatus} href="/stockManagementMenu/barcodes" i="i_bottle a_barcode_33 a_bottomright" background={background} name={admin_local.menus.barcodes}></MenuButton>
                      </CanAccess>
                    </div>
                  </CanAccess>
                </div>)
            } else return null;
          }} />
        </Switch>
      )
    else return null;
  }
}

const mapStateToProps = state => {
  return {
    admin_local: state.rootReducer.admin_local,
    myStatus: state.rootReducer.myStatus,
    local: state.rootReducer.local
  };
};

export default connect(mapStateToProps)(StockManagementMenu);
